import React, { useEffect, useState, Component } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { PackageIcon, ArrowRightIcon, CheckIcon, XIcon, TrendingUpIcon, BoxesIcon } from 'lucide-react';
export const ProductBundlesPage = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-5335">
      <Navbar scrolled={scrolled} data-id="element-5336" />
      <main className="pt-24 pb-20" data-id="element-5337">
        <div className="container mx-auto px-4 md:px-6" data-id="element-5338">
          <div className="max-w-4xl mx-auto" data-id="element-5339">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 md:p-12 mb-12 text-white relative overflow-hidden" data-id="element-5340">
              <div className="absolute right-0 bottom-0 opacity-10" data-id="element-5341">
                <BoxesIcon className="h-64 w-64" data-id="element-5342" />
              </div>
              <div className="relative z-10" data-id="element-5343">
                <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-5344">
                  Product Bundles That Sell
                </h1>
                <p className="text-xl opacity-90 max-w-3xl" data-id="element-5345">
                  Discover how to create irresistible product bundles that
                  increase your average order value and provide more value to
                  your customers.
                </p>
              </div>
            </div>
            {/* Main content */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-10 shadow-sm mb-10" data-id="element-5346">
              <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-5347">
                The Power of Product Bundling
              </h2>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-5348">
                Product bundling is a proven strategy that can significantly
                boost your revenue and provide more value to your customers. By
                combining complementary digital products into a single package,
                you can increase your average order value while giving customers
                a better deal than if they purchased items separately.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-5349">
                Studies show that well-designed bundles can increase revenue by
                15-30% compared to selling products individually, while also
                improving customer satisfaction through the perception of
                getting more value.
              </p>
              <div className="border-l-4 border-[#2DB489] dark:border-[#4ED1A0] pl-6 my-8 py-2" data-id="element-5350">
                <p className="text-lg font-medium text-gray-800 dark:text-[#F8FAF9] italic" data-id="element-5351">
                  "The key to successful bundling isn't just combining
                  products—it's creating packages that solve broader problems
                  for specific customer segments."
                </p>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mt-12 mb-6" data-id="element-5352">
                Types of Effective Digital Product Bundles
              </h2>
              <div className="mb-8" data-id="element-5353">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4 flex items-center" data-id="element-5354">
                  <span className="bg-[#2DB489] dark:bg-[#4ED1A0] text-white w-8 h-8 rounded-full flex items-center justify-center mr-3" data-id="element-5355">
                    1
                  </span>
                  Complementary Product Bundles
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-4 ml-11" data-id="element-5356">
                  Combine products that work well together to solve a larger
                  problem or create a complete solution.
                </p>
                <div className="ml-11 bg-gray-50 dark:bg-[#1A3330] p-5 rounded-lg mb-6" data-id="element-5357">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-5358">
                    Example:
                  </p>
                  <div className="flex flex-col md:flex-row gap-4" data-id="element-5359">
                    <div className="flex-1 bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5360">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-5361">
                        Website Template Bundle
                      </p>
                      <ul className="text-sm text-gray-600 dark:text-[#B0C1BD] space-y-1" data-id="element-5362">
                        <li data-id="element-5363">• Main website template</li>
                        <li data-id="element-5364">• Matching email newsletter template</li>
                        <li data-id="element-5365">• Social media graphics pack</li>
                        <li data-id="element-5366">• Brand style guide template</li>
                      </ul>
                      <p className="mt-3 text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-5367">
                        Complete brand presence across multiple channels
                      </p>
                    </div>
                    <div className="flex-1 bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5368">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-5369">
                        Notion Productivity Bundle
                      </p>
                      <ul className="text-sm text-gray-600 dark:text-[#B0C1BD] space-y-1" data-id="element-5370">
                        <li data-id="element-5371">• Project management system</li>
                        <li data-id="element-5372">• Client CRM template</li>
                        <li data-id="element-5373">• Invoice tracker</li>
                        <li data-id="element-5374">• Content calendar</li>
                      </ul>
                      <p className="mt-3 text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-5375">
                        Complete business management system in one package
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8" data-id="element-5376">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4 flex items-center" data-id="element-5377">
                  <span className="bg-[#2DB489] dark:bg-[#4ED1A0] text-white w-8 h-8 rounded-full flex items-center justify-center mr-3" data-id="element-5378">
                    2
                  </span>
                  Tiered Bundles
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-4 ml-11" data-id="element-5379">
                  Offer different bundle sizes (small, medium, large) with
                  increasing value at each tier to appeal to different customer
                  segments.
                </p>
                <div className="ml-11 bg-gray-50 dark:bg-[#1A3330] p-5 rounded-lg mb-6" data-id="element-5380">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-5381">
                    Example: UI Component Library
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-5382">
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5383">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-5384">
                        Starter Pack
                      </p>
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5385">
                        50 essential components
                      </p>
                      <p className="text-sm font-medium text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5386">
                        $39
                      </p>
                    </div>
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg border-2 border-[#2DB489] dark:border-[#4ED1A0]" data-id="element-5387">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-5388">
                        Pro Pack
                      </p>
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5389">
                        150 components + design system
                      </p>
                      <p className="text-sm font-medium text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5390">
                        $79
                      </p>
                      <p className="text-xs text-gray-500 dark:text-[#7A8F8A] mt-2" data-id="element-5391">
                        Most popular
                      </p>
                    </div>
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5392">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-5393">
                        Enterprise Pack
                      </p>
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5394">
                        300+ components + source files
                      </p>
                      <p className="text-sm font-medium text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5395">
                        $129
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8" data-id="element-5396">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4 flex items-center" data-id="element-5397">
                  <span className="bg-[#2DB489] dark:bg-[#4ED1A0] text-white w-8 h-8 rounded-full flex items-center justify-center mr-3" data-id="element-5398">
                    3
                  </span>
                  Cross-Category Bundles
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-4 ml-11" data-id="element-5399">
                  Combine products from different categories that appeal to the
                  same target audience to increase exposure for your less
                  popular products.
                </p>
                <div className="ml-11 bg-gray-50 dark:bg-[#1A3330] p-5 rounded-lg mb-6" data-id="element-5400">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-5401">
                    Example: Creator Bundle
                  </p>
                  <ul className="text-sm text-gray-600 dark:text-[#B0C1BD] space-y-3" data-id="element-5402">
                    <li className="flex items-start" data-id="element-5403">
                      <span className="bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 w-6 h-6 rounded-full flex items-center justify-center mr-2 flex-shrink-0" data-id="element-5404">
                        1
                      </span>
                      <div data-id="element-5405">
                        <p className="font-medium text-gray-700 dark:text-[#C4D1CC]" data-id="element-5406">
                          YouTube Thumbnail Templates
                        </p>
                        <p className="text-gray-500 dark:text-[#7A8F8A]" data-id="element-5407">
                          For video creators
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-5408">
                      <span className="bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 w-6 h-6 rounded-full flex items-center justify-center mr-2 flex-shrink-0" data-id="element-5409">
                        2
                      </span>
                      <div data-id="element-5410">
                        <p className="font-medium text-gray-700 dark:text-[#C4D1CC]" data-id="element-5411">
                          Content Calendar System
                        </p>
                        <p className="text-gray-500 dark:text-[#7A8F8A]" data-id="element-5412">
                          For planning content
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-5413">
                      <span className="bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 w-6 h-6 rounded-full flex items-center justify-center mr-2 flex-shrink-0" data-id="element-5414">
                        3
                      </span>
                      <div data-id="element-5415">
                        <p className="font-medium text-gray-700 dark:text-[#C4D1CC]" data-id="element-5416">
                          Social Media Caption Templates
                        </p>
                        <p className="text-gray-500 dark:text-[#7A8F8A]" data-id="element-5417">
                          For promoting content
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mt-12 mb-6" data-id="element-5418">
                Pricing Strategies for Bundles
              </h2>
              <div className="bg-gray-50 dark:bg-[#1A3330] p-6 rounded-xl mb-8" data-id="element-5419">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4" data-id="element-5420">
                  Finding the Right Discount Level
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-5421">
                  The discount you offer on bundles needs to be significant
                  enough to motivate purchase but not so large that it devalues
                  your products or cuts too deeply into your margins.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-5422">
                  <div className="bg-white dark:bg-[#162825] p-5 rounded-lg" data-id="element-5423">
                    <h4 className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-5424">
                      Too Small
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5425">
                      5-10% discount
                    </p>
                    <div className="flex items-start" data-id="element-5426">
                      <XIcon className="h-5 w-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-5427" />
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD]" data-id="element-5428">
                        Not enough incentive to purchase the bundle
                      </p>
                    </div>
                  </div>
                  <div className="bg-white dark:bg-[#162825] p-5 rounded-lg border-2 border-[#2DB489] dark:border-[#4ED1A0]" data-id="element-5429">
                    <h4 className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-5430">
                      Optimal
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5431">
                      15-30% discount
                    </p>
                    <div className="flex items-start" data-id="element-5432">
                      <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-5433" />
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD]" data-id="element-5434">
                        Attractive enough to motivate purchase while maintaining
                        value perception
                      </p>
                    </div>
                  </div>
                  <div className="bg-white dark:bg-[#162825] p-5 rounded-lg" data-id="element-5435">
                    <h4 className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-5436">
                      Too Large
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5437">
                      50%+ discount
                    </p>
                    <div className="flex items-start" data-id="element-5438">
                      <XIcon className="h-5 w-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-5439" />
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD]" data-id="element-5440">
                        May devalue your products and train customers to wait
                        for deep discounts
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white dark:bg-[#162825] p-5 rounded-lg" data-id="element-5441">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-5442">
                    Pricing Example:
                  </p>
                  <div className="space-y-3" data-id="element-5443">
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-5444">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5445">
                        Website Template
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5446">
                        $59
                      </span>
                    </div>
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-5447">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5448">
                        Email Template
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5449">
                        $29
                      </span>
                    </div>
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-5450">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5451">
                        Social Media Pack
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5452">
                        $39
                      </span>
                    </div>
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-5453">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5454">
                        Individual Total
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-5455">
                        $127
                      </span>
                    </div>
                    <div className="flex items-center justify-between font-medium" data-id="element-5456">
                      <span className="text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5457">
                        Bundle Price (20% off)
                      </span>
                      <span className="text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5458">
                        $99
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-t border-gray-200 dark:border-[#1A3330] pt-10 mt-10" data-id="element-5459">
                <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-5460">
                  Case Study: Successful Bundle Strategy
                </h2>
                <div className="bg-gray-50 dark:bg-[#1A3330] rounded-xl p-6 mb-8" data-id="element-5461">
                  <div className="flex items-center mb-4" data-id="element-5462">
                    <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-5463">
                      <img src="https://randomuser.me/api/portraits/men/41.jpg" alt="James Cooper" className="w-full h-full object-cover" data-id="element-5464" />
                    </div>
                    <div data-id="element-5465">
                      <h3 className="font-medium text-gray-800 dark:text-[#F8FAF9]" data-id="element-5466">
                        James Cooper
                      </h3>
                      <p className="text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-5467">
                        UI Kit Creator
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-600 dark:text-[#B0C1BD] mb-4" data-id="element-5468">
                    "I had been selling individual UI component packs for
                    different purposes - dashboards, e-commerce, and mobile
                    apps. Each was priced at $49 and sold moderately well. After
                    analyzing my sales data, I noticed many customers would
                    eventually buy more than one pack."
                  </p>
                  <p className="text-gray-600 dark:text-[#B0C1BD] mb-4" data-id="element-5469">
                    "I decided to create a 'Complete UI System' bundle that
                    included all three packs plus a bonus style guide template.
                    I priced it at $119 (a 20% discount off buying separately).
                    Within the first month, the bundle became my best-selling
                    product, and my overall revenue increased by 35%."
                  </p>
                  <div className="mt-6 grid grid-cols-2 gap-4 text-center" data-id="element-5470">
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5471">
                      <p className="text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-5472">
                        Before Bundling
                      </p>
                      <p className="text-xl font-bold text-gray-700 dark:text-[#C4D1CC]" data-id="element-5473">
                        $3,500/month
                      </p>
                    </div>
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-5474">
                      <p className="text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-5475">
                        After Bundling
                      </p>
                      <p className="text-xl font-bold text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5476">
                        $4,725/month
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-[#0D3C45]/5 dark:bg-[#0D3C45]/20 rounded-xl p-6 mt-12" data-id="element-5477">
                <h2 className="text-xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-4" data-id="element-5478">
                  Key Takeaways
                </h2>
                <ul className="space-y-3" data-id="element-5479">
                  <li className="flex items-start" data-id="element-5480">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-5481">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-5482" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-5483">
                      Bundle complementary products that solve a larger problem
                      for your customers
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-5484">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-5485">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-5486" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-5487">
                      Aim for a 15-30% discount to make bundles attractive while
                      maintaining value perception
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-5488">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-5489">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-5490" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-5491">
                      Create tiered bundles to appeal to different customer
                      segments and budgets
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-5492">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-5493">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-5494" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-5495">
                      Clearly communicate the value and savings of your bundle
                      compared to buying products individually
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            {/* Related resources */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm mb-10" data-id="element-5496">
              <h2 className="text-xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-5497">
                Related Resources
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5498">
                <a href="/learn/pricing-strategies" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-5499">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-5500">
                    Pricing Your Digital Products
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5501">
                    Learn proven strategies for pricing your digital products to
                    maximize sales and revenue.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-5502">
                    <span data-id="element-5503">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-5504" />
                  </div>
                </a>
                <a href="/learn/limited-offers" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-5505">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-5506">
                    Creating Limited-Time Offers
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5507">
                    Strategies for creating urgency and scarcity to boost sales
                    of your digital products.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-5508">
                    <span data-id="element-5509">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-5510" />
                  </div>
                </a>
              </div>
            </div>
            {/* CTA */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 text-white text-center" data-id="element-5511">
              <h2 className="text-2xl font-bold mb-4" data-id="element-5512">
                Ready to create your own product bundles?
              </h2>
              <p className="text-lg opacity-90 mb-6 max-w-2xl mx-auto" data-id="element-5513">
                Apply these bundle strategies to your digital products and start
                increasing your average order value today.
              </p>
              <a href="/sell-product" className="inline-block bg-white text-[#0D3C45] px-6 py-3 rounded-lg font-medium hover:bg-opacity-90 transition-all" data-id="element-5514">
                Start Selling
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-5515" />
    </div>;
};